import React from "react";
import { Typography, Grid } from "@material-ui/core";

export default function StepDescription({ top, bottom, current }) {
    const classNames = ["step-text"];
    const containerClassName = ["step-text-container"];

    if (current) {
        classNames.push("step-text-current");
        containerClassName.push("step-text-container-current");
    }

    return (
        <Grid
            container
            direction="column"
            style={{ width: "fit-content" }}
            className={containerClassName.join(" ")}
        >
            <Typography className={classNames.join(" ")}>{top}</Typography>
            <Typography
                className={classNames.join(" ")}
                style={{ border: "none" }}
            >
                {bottom}
            </Typography>
        </Grid>
    );
}



// WEBPACK FOOTER //
// ./src/Order/StepDescription.jsx